<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="title-invert">Manage Abstracts for QC Coding</h1>
  </div>
</div>
<div class="row">
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <app-manage-queue-information [model]="teamQueueInformation"></app-manage-queue-information>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="title-invert">Enqueue Abstracts</h1>
  </div>
</div>
<div class="row">
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <app-manage-queue-enqueue 
            [model]="teamQueueEnqueue"
            (modelChange)="enqueueModelChange($event)"
            (enqueue)="enqueueClick($event)" [isUpdating]="isUpdating"></app-manage-queue-enqueue>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="title-invert">Edit Queue</h1>
  </div>
</div>

<div class="row">
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <app-manage-queue-edit [(model)]="teamQueueEdit" (saveChanges)="submitQueueChanges()" (errorMessage)="displayQueueError($event)" [isUpdating]="isUpdating" [hasUnsavedChanges]="editHasUnsavedChanges" (unsavedChanges)="updateUnsavedChanges($event)"></app-manage-queue-edit>
        </div>
      </div>
    </div>
  </div>
</div>
